/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./facescan.vue?vue&type=template&id=e1e582be&scoped=true"
import script from "./facescan.vue?vue&type=script&lang=js"
export * from "./facescan.vue?vue&type=script&lang=js"
import style0 from "./facescan.vue?vue&type=style&index=0&id=e1e582be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e582be",
  null
  
)

export default component.exports